module.exports = __webpack_public_path__ + "img/source_book-item9.c132e2c1.png";